/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Show_Event_LabelInputs */



/**
* | output |
* | --- |
* | "Show Event" |
*
* @param {Timing_Sync_Show_Event_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_show_event_label = /** @type {((inputs?: Timing_Sync_Show_Event_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Show_Event_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltung anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выставочное мероприятие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("演出活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento de Exibição")
	return /** @type {LocalizedString} */ ("Show Event")
});